import React from 'react';
import ModalWrapper from '../ModalWrapper';

const ConfirmModal = ({ submitText, title, handleSubmit, modalId, text = '', children = null }) => (
  <ModalWrapper title={title} handleSubmit={handleSubmit} modalId={modalId} submitText={submitText}>
    {text}
    {children}
  </ModalWrapper>
);

export default ConfirmModal;
